import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { Message as TicketMessage } from "entities/customerTickets/types";
import React, { FC, Fragment } from "react";
import {
  COLOR_GREY_11,
  COLOR_GREY_12,
  COLOR_GREY_2,
} from "shared/theme/colors";
import { formatStringWithLink } from "shared/utils/formatStringWithLink";
import { urlRegex } from "shared/utils/regexPatterns/UrlRegex";
import UserInfo from "../../../../../../../UserInfo";
import { StyledMessage } from "../../styled";
import { findCategoryKey } from "./helpers";
import { useCustomerTicketsPage } from "modules/customerTickets/pages/CustomerTickets/context";
import { getMessageDate } from "modules/customerTickets/pages/CustomerTickets/helpers";

type Props = {
  message: TicketMessage;
};

const UserMessage: FC<Props> = ({ message }) => {
  const { selectedTicket, ticketsBgColors, selectedUserId } =
    useCustomerTicketsPage();
  const ticketAvatarBgColor =
    ticketsBgColors.find(({ id }) => id === selectedTicket?.id)?.bgColor || "";

  if (!selectedTicket || !message) {
    return null;
  }

  const formattedMessage = formatStringWithLink(
    findCategoryKey(message.message),
  );

  return (
    <>
      <UserInfo
        userId={selectedUserId}
        userName={selectedTicket.userName}
        isHiddenUserName={true}
        bgColor={ticketAvatarBgColor}
      />
      <Box display="flex" flexDirection="column" width="100%" rowGap="6px">
        <Box display="flex" justifyContent="space-between" width="100%">
          <Typography variant="bodyMSemiBold" color={COLOR_GREY_12}>
            {selectedTicket.userName}
          </Typography>
          <Typography variant="bodySRegular" color={COLOR_GREY_11}>
            {message.timestamp && getMessageDate(message.timestamp.toDate())}
          </Typography>
        </Box>
        <StyledMessage isMessageFromUser={true} bgColor={COLOR_GREY_2}>
          <Typography variant="bodyMRegular" color={COLOR_GREY_12}>
            {formattedMessage.map((message, idx) => {
              return (
                <Fragment key={idx}>
                  {message.match(urlRegex) ? (
                    <>
                      {" "}
                      <Link
                        href={message}
                        underline="always"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {message}
                      </Link>
                    </>
                  ) : (
                    message
                  )}
                </Fragment>
              );
            })}
          </Typography>
        </StyledMessage>
      </Box>
    </>
  );
};

export default UserMessage;
